import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8e59de4e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=8e59de4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e59de4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e59de4e')) {
      api.createRecord('8e59de4e', component.options)
    } else {
      api.reload('8e59de4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8e59de4e&scoped=true&", function () {
      api.rerender('8e59de4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/view-team/index.vue"
export default component.exports